<template>
  <div class="adult-check-view adult-password">
    <!-- common -->
    <div class="adult-check-page">
      <div class="wrap">
        <div class="ch-adult-wrap">
          <span class="adult-tag">
            <Over19Icon />
          </span>
          <div>
            <strong class="ch-adult-title">연령 제한 콘텐츠</strong>
            <p class="ch-adult-text01">
              자녀 보호 설정에 의해 이용할 수 없습니다. <br/>
              Wavve에서 설정을 변경해주세요.
            </p>
            <span class="adult-exclamation-setting">
              설정 변경 방법:<br/>
              ① Wavve 앱 또는 웹 접속<br/>
              ② MY > 설정 > 자녀 보호 설정<br/>
              ③ '차단하지 않음'으로 설정 변경<br/>
            </span>
          </div>
          <div class="ch-adult-btn">
            <ul>
              <li><a @click.prevent="exit()" href="#" class="round-btn-black-b">나가기</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { get } from 'lodash'
import Over19Icon from '@/assets/svg/common/img-age-19-ll.svg'
import { closeWindow } from '@/common/utils/apollo.interface'
export default {
  name: 'AdultContentUnLockForApollo',
  components: {
    Over19Icon
  },
  data () {
    return {
      referer: get(this.$route, 'query.referer', '')
    }
  },
  methods: {
    exit () {
      this.$nextTick(() => {
        if (this.referer.indexOf('/apollo') > -1) {
          // referer가 아폴로 페이지인 경우(아폴로페이지에서 추천, 다음회차 등으로 성인 컨텐츠 들어온 경우) 이전 페이지 이동
          this.$router.back()
        } else {
          // 그게 아닌 경우는 아폴로 웹뷰 닫기
          if (!closeWindow()) {
            // 웹뷰 닫기 실패시 걍 이전 페이지 이동
            this.$router.back()
          }
        }
      })
    }
  }
}
</script>
